import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'
import './i18n'

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register("./service-worker.js")
            .then(function (registration) {
                console.log("ServiceWorker registration successful, scope is:", registration.scope)
            })
            .catch(function (error) {
                console.log("Service worker registration failed, error:", error)
            })
    })
}

ReactDOM.render(<App />, document.getElementById('root'))